/** --------- util fetch JSON com erro legível --------- */
const jfetch = (url, opts = {}) =>
  fetch(url, { credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, ...opts })
    .then(async r => {
      const text = await r.text().catch(()=> '');
      if (!r.ok) {
        let parsed; try { parsed = text ? JSON.parse(text) : null; } catch {}
        const err = new Error(`HTTP ${r.status}`);
        err.status = r.status; err.body = text; err.parsed = parsed;
        throw err;
      }
      return text ? JSON.parse(text) : {};
    });

/** API Cart Shopify */
const CartAPI = {
  get:    () => jfetch('/cart.js'),
  update: (updatesObj) => jfetch('/cart/update.js', {
    method:'POST',
    body: JSON.stringify({ updates: updatesObj })
  })
};

/** --------- Singleton (com rollback + evento de erro) --------- */
window.__CartSync ||= (() => {
  let map = new Map();
  let queue = Promise.resolve();
  const listeners = new Set();
  let raf = 0;

  const notify = () => { if (!raf) raf = requestAnimationFrame(() => { raf=0; listeners.forEach(fn=>fn(map)); }); };

  const refresh = () => CartAPI.get().then(cart => {
    const m = new Map();
    (cart.items||[]).forEach(it => m.set(it.variant_id, it.quantity));
    map = m; notify(); return map;
  });

  const setAbsolute = (variantId, qty) => {
    const id = Number(variantId);
    const q  = Math.max(0, Number.isFinite(qty) ? qty|0 : 0);
    if (!Number.isFinite(id) || id <= 0) return Promise.resolve(map);

    queue = queue.then(() => {
      const prev = new Map(map);        // snapshot para rollback
      map.set(id, q); notify();         // otimista
      return CartAPI.update({ [id]: q })
        .then(refresh)
        .catch(err => {
          console.error(err);
          map = prev; notify();         // rollback visual
          window.dispatchEvent(new CustomEvent('cart:error', {
            detail: { variantId: id, quantity: q, status: err.status, error: err.parsed || err.body }
          }));
          return refresh();
        });
    });
    return queue;
  };

  const on = fn => (listeners.add(fn), () => listeners.delete(fn));
  refresh();

  const ingest = (cart) => {
    const m = new Map();
    (cart.items || []).forEach(it => m.set(it.variant_id, it.quantity));
    map = m; notify();
    return map;
  };

  return { on, refresh, setAbsolute, ingest, get qty(){ return map; } };
})();

/** --------- Web Component --------- */
class ProductCardExpress extends HTMLElement {
  static get observedAttributes(){ return ['data-variant-id','data-stock','data-approved','data-available']; }

  connectedCallback(){
    if (this._inited) return;
    this._inited = true;

    this.$box     = this.querySelector('quantity-express');
    this.$minus   = this.querySelector('.express-minus');
    this.$plus    = this.querySelector('.express-plus');
    this.$display = this.querySelector('.display-quantity');
    this.$addBtn  = this.querySelector('.add-to-cart');

    this._labels = {
      add:    this.$addBtn?.dataset.labelAdd    || 'Adicionar',
      update: this.$addBtn?.dataset.labelUpdate || 'Adicionar'
    };

    this._readAttrs();
    this._bind();
    this._unsub = window.__CartSync.on(() => this._render());
    // ouvir erros do carrinho (ex.: 422 sem estoque)
    this.__onCartError = (e) => {
      const { variantId, status } = e.detail || {};
      if (variantId !== this.variantId) return;
      if (status === 422 || status === 400) this._showOutOfStock();
    };
    window.addEventListener('cart:error', this.__onCartError);

    this._render();
    this.dispatchEvent(new CustomEvent('product:ready', { bubbles:true, detail:{ el:this }}));
  }

  disconnectedCallback(){
    this._unsub?.();
    window.removeEventListener('cart:error', this.__onCartError);
  }

  attributeChangedCallback(){ this._readAttrs(); this._render(); }

  _readAttrs(){
    const d = this.dataset;
    this.variantId = Number(d.variantId);
    this.stock     = Math.max(0, Number(d.stock ?? 999999));
    this.approved  = d.approved  === 'true' || d.approved  === '1';
    this.available = d.available === 'true' || d.available === '1';
  }

  _isAtMax(q = this._getQtyNow()){
    return Number.isFinite(this.stock) && q >= this.stock;
    }

  _pulseMax(){
    this.$box?.classList.add('error','shake');
    this.$box && (this.$box.dataset.error = 'Sem estoque');
    setTimeout(()=> this.$box?.classList.remove('shake'), 300);
    setTimeout(()=> this._clearError(), 1200);
  }

  _bind(){
    const qtyNow = () => window.__CartSync.qty.get(this.variantId) || 0;
    const guard = (fn) => (ev) => { if (this._busy || ev?.currentTarget?.disabled) return; fn(); };

    if (this.$addBtn && !this.$addBtn._bound) {
        this.$addBtn._bound = true;
        const qtyNow = () => window.__CartSync.qty.get(this.variantId) || 0;
        const guard = (fn) => (ev) => { if (this._busy || ev?.currentTarget?.disabled) return; fn(); };

        this.$addBtn.addEventListener('click', guard(() => {
            const cur = qtyNow();
            if (this._isAtMax(cur)) {            // no limite? não envia request
            this.$box?.classList.add('error','shake');
            this.$box && (this.$box.dataset.error = 'Sem estoque');
            setTimeout(()=> this.$box?.classList.remove('shake'), 300);
            setTimeout(()=> { this.$box?.classList.remove('error'); this.$box?.removeAttribute('data-error'); }, 1200);
            return;
            }
            this._set(Math.min(cur + 1, this.stock));
        }), { passive: true });
    }


    if (this.$plus && !this.$plus._bound) {
      this.$plus._bound = true;
      this.$plus.addEventListener('click', guard(() => {
        this._set(Math.min(qtyNow() + 1, this.stock));
      }), { passive: true });
    }
    if (this.$minus && !this.$minus._bound) {
      this.$minus._bound = true;
      this.$minus.addEventListener('click', guard(() => {
        this._set(Math.max(qtyNow() - 1, 0));
      }), { passive: true });
    }
  }

  _getQtyNow(){ return window.__CartSync.qty.get(this.variantId) || 0; }

  // --- helpers de loading/erro
  _showBoxLoading(q){
    if (!this.$box) return;
    this.$box.removeAttribute('hidden');       // aparece já no 1º add
    this.$box.classList.add('loading');        // spinner no número
    this.$minus?.setAttribute('disabled','');  // trava botões
    this.$plus?.setAttribute('disabled','');
    this.setAttribute('aria-busy','true');
    if (this.$display) this.$display.textContent = q; // valor otimista
  }
  _unlockBox(){
    // só tira o loading; quem decide habilitar/desabilitar é o _render()
    this.$box?.classList.remove('loading');
    this.removeAttribute('aria-busy');
    this._render(); // recalc dos botões conforme qty/stock atuais
  }
  _showOutOfStock(){
    if (!this.$box) return;
    this.$box.removeAttribute('hidden');
    this.$box.dataset.error = 'Sem estoque';
    this.$box.classList.add('error','shake');
    setTimeout(()=> this.$box?.classList.remove('shake'), 350);
    setTimeout(()=> this._clearError(), 2000);
    this._unlockBox();
  }
  _clearError(){
    if (!this.$box) return;
    this.$box.classList.remove('error','shake');
    this.$box.removeAttribute('data-error');
  }

  // --- coalescing + UX otimista com rollback em erro
  _set(q){
    // clamp local pelo estoque (servidor ainda valida)
    if (Number.isFinite(this.stock)) q = Math.min(q, this.stock);

    if (this._busy) { this._pending = q; return; }
    this._busy = true; this._pending = undefined;

    const prev = this._getQtyNow();
    this._showBoxLoading(q);

    window.__CartSync.setAbsolute(this.variantId, q)
      .then(() => {
        const nextPending = this._pending;
        this._busy = false;

        if (typeof nextPending === 'number' && nextPending !== this._getQtyNow()) {
          this._set(nextPending);              // mantém loading
          return;
        }

        this._clearError();
        this._unlockBox();                     // sucesso
        window.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { variantId: this.variantId, quantity: this._getQtyNow() }
        }));
      })
      .catch(() => {
        // CartSync já fez rollback e emitiu cart:error
        this._busy = false;
        if (prev === 0) {                      // 1º add falhou → oculta de volta
          this.$box?.setAttribute('hidden','');
          if (this.$display) this.$display.textContent = prev;
        }
        this._unlockBox();
      });
  }

  _render(){
    const qty = this._getQtyNow();
    if (this.$box) (qty > 0) ? this.$box.removeAttribute('hidden') : this.$box.setAttribute('hidden','');

    const atMax = this._isAtMax(qty);
    if (this.$plus)  atMax ? this.$plus.setAttribute('disabled','') : this.$plus.removeAttribute('disabled');
    if (this.$minus) (qty <= 0) ? this.$minus.setAttribute('disabled','') : this.$minus.removeAttribute('disabled');

    if (this.$addBtn){
        const outOfStockGlobal = (this.stock === 0 && qty === 0) || !this.available;
        const blocked = !this.approved || !this.available || (qty > 0 && atMax);
        blocked ? this.$addBtn.setAttribute('disabled','') : this.$addBtn.removeAttribute('disabled');
        this.$addBtn.textContent = outOfStockGlobal ? 'Esgotado' : (qty > 0 ? this._labels.update : this._labels.add);
    }

    if (this.$display) this.$display.textContent = qty;
  }


}
customElements.define('product-card-express', ProductCardExpress);

/** --------- Hidratação idempotente + init em lote --------- */
function hydrateProductCards(root = document) {
  root.querySelectorAll('div.product-card-express').forEach(div => {
    if (div.__hydrated) return;
    div.__hydrated = true;
    const el = document.createElement('product-card-express');
    [...div.attributes].forEach(a => el.setAttribute(a.name, a.value));
    el.innerHTML = div.innerHTML;
    div.replaceWith(el);
  });
}
hydrateProductCards();
window.initNewProductCards = (container) => hydrateProductCards(container);

/** --------- Re-render global após atualizações --------- */
function __forceRenderAllCards() {
  document.querySelectorAll('product-card-express').forEach(el => el._render?.());
}

(() => {
  const cart = window.__CartSync;
  if (!cart || cart.__patched) return;
  cart.__patched = true;

  const _refresh = cart.refresh.bind(cart);
  cart.refresh = () =>
    _refresh().then((out) => {
      window.dispatchEvent(new CustomEvent('cart:refreshed', { detail: { map: cart.qty } }));
      __forceRenderAllCards();
      return out;
    });

  const _setAbs = cart.setAbsolute.bind(cart);
  cart.setAbsolute = (id, q) =>
    _setAbs(id, q).then((out) => {
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: { variantId: Number(id), quantity: q }}));
      __forceRenderAllCards();
      return out;
    });
})();

window.addEventListener('cart:updated',   __updateSideCart);
window.addEventListener('cart:error',     __updateSideCart);

/** opcional: hidrate após append dinâmico automaticamente */
// window.initNewProductCards?.(document);
